import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Screens/Home";
import TermsAndConditions from "./Screens/Legals/TermsCs";
import DeleteAccount from "./Screens/DeleteAccount";

function App() {
  return (
    // basename="/parsal/web"
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:page" element={<TermsAndConditions />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
    </Router>
  );
}

export default App;
